module.exports = __webpack_public_path__ + "static/img/f1.af0ce98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/high-rise/f1.png
// module id = 88LZ
// module chunks = 0